<template>
    <div>
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0 text-capitalize">Countries</h1>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <router-link to="/">Home</router-link>
                            </li>
                            <li class="breadcrumb-item">Reports</li>
                            <li class="breadcrumb-item active text-capitalize">
                                <i class="fas fa-list"></i> Countries
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <section class="content">
            <div class="container-fluid">
                <div class="form-group">
                    <div class="btn-group btn-group-toggle">
                        <label class="btn btn-default" :class="{active: mode === 'ip'}">
                            <input type="radio" value="ip" v-model="mode"> {{ $t('By IP') }}
                        </label>
                        <label class="btn btn-default" :class="{active: mode === 'currency'}">
                            <input type="radio" value="currency" v-model="mode"> {{ $t('By currency') }}
                        </label>
                    </div>
                </div>

                <data-table-wrapper
                    :key="mode"
                    ref="dataTable"
                    :columns="columns"
                    :filters="filters"
                    :filter-defaults="filterDefaults"
                    :show-filters="true"
                    disable-primary-column="true"
                    disable-edit-action="true"
                    disable-delete-action="true"
                    :endpoint="endpoint"
                    api-service="analytics"
                    sort-column-default="playersCount"
                    sort-order-default="DESC"
                >
                    <template v-slot:filter-buttons>
                        <button class="btn btn-default float-right" @click="doExport">
                            <span v-if="!exportInProgress">
                                <i class="fa fa-cloud-download"></i> {{ $t('Export') }}
                            </span>
                            <span v-else>
                                <i class="fas fa-spinner fa-pulse"></i> {{ $t('Export') }}
                            </span>
                        </button>
                        <button class="btn btn-default float-right mr-2" @click="doAiAnalysis">
                            <span v-if="!aiInProgress">
                                <i class="fas fa-robot"></i> {{ $t('AI Analysis') }}
                            </span>
                            <span v-else>
                                <i class="fas fa-spinner fa-pulse"></i> {{ $t('AI Analysis') }}
                            </span>
                        </button>
                    </template>
                </data-table-wrapper>
            </div>
        </section>
    </div>
</template>

<script>
import * as dateUtils from '../helpers/dateUtils';
import DataTableWrapper from '../components/DataTableWrapper';
import {mapGetters} from 'vuex';
import {openAiAnalysis} from '../services/aiAnalysis';

export default {
    components: {
        DataTableWrapper,
    },
    data() {
        return {
            mode: 'ip',
            exportInProgress: false,
            aiInProgress: false,
            filters: [
                {
                    field: 'fromDate',
                    placeholder: 'From Date',
                    label: 'From Date',
                    type: 'date-picker',
                    shortcuts: dateUtils.getFilterShortcuts()
                },
                {
                    field: 'toDate',
                    placeholder: 'To Date',
                    label: 'To Date',
                    type: 'date-picker',
                    shortcuts: dateUtils.getFilterShortcuts()
                },
                {
                    field: 'partnerIds',
                    placeholder: 'Select partners',
                    label: 'Partners',
                    type: 'multiselect',
                    optionLabel: 'name',
                    multiple: true,
                    getValue: (partners) => { return partners ? partners.map(partner => partner.id) : [] },
                    getOptions: () => this.getPartners,
                    trackBy: 'id'
                },
                {
                    field: 'operatorIds',
                    placeholder: 'Select operators',
                    label: 'Operators',
                    type: 'multiselect',
                    optionLabel: 'name',
                    multiple: true,
                    getValue: (operators) => { return operators ? operators.map(operator => operator.id) : [] },
                    getOptions: () => this.getOperators,
                    trackBy: 'id'
                },
            ],
        };
    },
    computed: {
        ...mapGetters([
            'getPartners',
            'getOperators',
        ]),
        endpoint() {
            return this.mode === 'currency'
                ? '/countries-report/by-currency'
                : '/countries-report/by-ip';
        },
        filterDefaults() {
            return {
                fromDate: dateUtils.getTodayDate()
            };
        },
        columns() {
            return [
                {
                    field: 'country',
                    title: this.mode === 'currency' ? 'Currency' : 'Country',
                    sorting: true,
                },
                {
                    field: 'playersCount',
                    title: 'Players',
                    sorting: true,
                },
            ];
        },
    },
    methods: {
        doExport() {
            if (this.exportInProgress) {
                return;
            }
            this.exportInProgress = true;
            let type = this.mode === 'currency'
                ? 'countries-report/by-currency'
                : 'countries-report/by-ip';
            this.$exportService.doExport(type, this.$refs.dataTable.getPageQuery()).finally(() => {
                this.exportInProgress = false;
            });
        },
        doAiAnalysis() {
            if (this.aiInProgress) {
                return;
            }
            this.aiInProgress = true;
            openAiAnalysis(this.$http, 'countries-report/ai-analysis', this.$refs.dataTable.getPageQuery())
                .finally(() => {
                    this.aiInProgress = false;
                });
        },
    },
};
</script>
